(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wy-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-accordion')) {
    customElements.define('wy-accordion', class extends HTMLElement {
      connectedCallback() {
        this.items = this.querySelectorAll('[data-accordion-item]');
        this.items.forEach((item) => {
          const header = item.querySelector('.ai-accordion-header');
          header.addEventListener('click', () => this.toggle(item, header));
        });
      }
      toggle(item, header) {
        const active = item.classList.contains('active');
        this.items.forEach((o) => { if (o !== item) { o.classList.remove('active'); o.querySelector('.ai-accordion-header').setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('active', !active);
        header.setAttribute('aria-expanded', String(!active));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-charms"] && !Shopify.designMode) return;
  try {
    (function () {
    var HEART = [
      { k: 'czerwone', label: 'Serce czerwone', color: '#e0455f', glyph: '♥' },
      { k: 'rozowe', label: 'Serce różowe', color: '#f4a6c1', glyph: '♥' }
    ];
    var STONE = [
      { k: 'styczen', label: 'Kamień – Styczeń (Granat czerwony)', color: '#8B1E2B' },
      { k: 'luty', label: 'Kamień – Luty (Ametyst fioletowy)', color: '#8E5FA6' },
      { k: 'marzec', label: 'Kamień – Marzec (Akwamaryn niebieski)', color: '#6FA8DC' },
      { k: 'kwiecien', label: 'Kamień – Kwiecień (Kryształ bezbarwny)', color: '#D9D9D9' },
      { k: 'maj', label: 'Kamień – Maj (Szmaragd zielony)', color: '#2E8B57' },
      { k: 'czerwiec', label: 'Kamień – Czerwiec (Aleksandryt purpurowy)', color: '#6A1B4D' },
      { k: 'lipiec', label: 'Kamień – Lipiec (Rubin różowy)', color: '#D6336C' },
      { k: 'sierpien', label: 'Kamień – Sierpień (Perydot zielony)', color: '#9ACD32' },
      { k: 'wrzesien', label: 'Kamień – Wrzesień (Szafir niebieski)', color: '#1B3F8B' },
      { k: 'pazdziernik', label: 'Kamień – Październik (Turmalin różowy)', color: '#E8A0BF' },
      { k: 'listopad', label: 'Kamień – Listopad (Cytryn żółty)', color: '#F4D35E' },
      { k: 'grudzien', label: 'Kamień – Grudzień (Topaz niebieski)', color: '#3FA9F5' }
    ];
    var ZODIAC = [
      { k: 'baran', label: 'Zodiak – Baran (21 mar – 19 kwi)', glyph: '♈' },
      { k: 'byk', label: 'Zodiak – Byk (20 kwi – 20 maj)', glyph: '♉' },
      { k: 'blizniata', label: 'Zodiak – Bliźnięta (21 maj – 20 cze)', glyph: '♊' },
      { k: 'rak', label: 'Zodiak – Rak (21 cze – 22 lip)', glyph: '♋' },
      { k: 'lew', label: 'Zodiak – Lew (23 lip – 22 sie)', glyph: '♌' },
      { k: 'panna', label: 'Zodiak – Panna (23 sie – 22 wrz)', glyph: '♍' },
      { k: 'waga', label: 'Zodiak – Waga (23 wrz – 22 paź)', glyph: '♎' },
      { k: 'skorpion', label: 'Zodiak – Skorpion (23 paź – 21 lis)', glyph: '♏' },
      { k: 'strzelec', label: 'Zodiak – Strzelec (22 lis – 21 gru)', glyph: '♐' },
      { k: 'koziorozec', label: 'Zodiak – Koziorożec (22 gru – 19 sty)', glyph: '♑' },
      { k: 'wodnik', label: 'Zodiak – Wodnik (20 sty – 18 lut)', glyph: '♒' },
      { k: 'ryby', label: 'Zodiak – Ryby (19 lut – 20 mar)', glyph: '♓' }
    ];
    var INITIAL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(function (l) { return { k: l, label: 'Inicjał – ' + l, glyph: l }; });

    var CATALOG = {};
    function reg(prefix, arr) { arr.forEach(function (it) { CATALOG[prefix + '::' + it.k] = Object.assign({ cat: prefix }, it); }); }
    reg('heart', HEART); reg('stone', STONE); reg('zodiac', ZODIAC); reg('initial', INITIAL);

    function optionsHTML() {
      function group(label, arr, prefix) {
        var h = '<optgroup label="' + label + '">';
        arr.forEach(function (it) { h += '<option value="' + prefix + '::' + it.k + '">' + it.label + '</option>'; });
        return h + '</optgroup>';
      }
      return group('Serce', HEART, 'heart') + group('Kamień urodzenia', STONE, 'stone') + group('Zodiak', ZODIAC, 'zodiac') + group('Inicjał', INITIAL, 'initial');
    }

    function setup(root) {
      if (root.__wyCharms) return;
      root.__wyCharms = true;

      var selects = Array.prototype.slice.call(root.querySelectorAll('.wy-charms__select'));
      var html = optionsHTML();
      selects.forEach(function (s) { s.insertAdjacentHTML('beforeend', html); });
      var preview = root.querySelector('[data-wy-charms-preview]');
      var resetBtn = root.querySelector('[data-wy-charms-reset]');
      var errorEl = root.querySelector('[data-wy-charms-error]');
      var variants = {};
      try { variants = JSON.parse(root.querySelector('[data-wy-charms-variants]').textContent); } catch (e) {}
      var defaultCount = parseInt(root.getAttribute('data-default-count'), 10) || 1;
      var currentCount = defaultCount;

      function form() {
        var f = root.closest('form[action*="/cart/add"]');
        if (!f) { var sec = root.closest('.product-information, section, main') || document; f = sec.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'); }
        return f;
      }
      function variantId() {
        var f = form(); if (!f) return null;
        var inp = f.querySelector('input[name="id"], select[name="id"]');
        return inp ? String(inp.value) : null;
      }
      function values() { return selects.map(function (s) { return s.value; }).filter(Boolean); }

      function refreshDisabled() {
        var used = values();
        selects.forEach(function (sel) {
          Array.prototype.forEach.call(sel.options, function (o) {
            if (!o.value) return;
            o.disabled = used.indexOf(o.value) !== -1 && o.value !== sel.value;
          });
        });
      }

      function syncHidden() {
        var f = form(); if (!f) return;
        selects.forEach(function (sel, idx) {
          var row = sel.closest('.wy-charms__row');
          var name = 'properties[Opcja ' + (idx + 1) + ']';
          var inp = f.querySelector('input[data-wy-charms-mirror="' + (idx + 1) + '"]');
          if (row.hidden) { if (inp) inp.remove(); return; }
          var it = CATALOG[sel.value];
          var val = it ? it.label : '';
          if (!inp) {
            inp = document.createElement('input');
            inp.type = 'hidden'; inp.setAttribute('data-wy-charms-mirror', String(idx + 1));
            inp.name = name; inp.value = val;
            f.appendChild(inp);
          } else if (inp.value !== val) {
            inp.value = val;
          }
        });
      }

      function refreshPreview() {
        preview.innerHTML = '';
        values().forEach(function (v) {
          var it = CATALOG[v]; if (!it) return;
          var span = document.createElement('span');
          span.className = 'wy-charms__charm'; span.setAttribute('data-cat', it.cat);
          if (it.cat === 'heart') span.style.color = it.color;
          if (it.cat === 'stone') span.style.background = it.color;
          span.textContent = it.glyph || '';
          preview.appendChild(span);
        });
        syncHidden();
      }

      function applyCount(n) {
        currentCount = n;
        root.querySelectorAll('.wy-charms__row').forEach(function (row) {
          var r = parseInt(row.getAttribute('data-row'), 10);
          row.hidden = r > n;
          if (r > n) row.querySelector('select').value = '';
        });
        refreshDisabled(); refreshPreview();
      }

      var lastVariant = null;
      function syncFromVariant() {
        var id = variantId();
        if (!id || id === lastVariant) { syncHidden(); return; }
        lastVariant = id;
        var v = variants[id];
        if (v) {
          var metal = v.metal || 'gold';
          if (preview.getAttribute('data-metal') !== metal) preview.setAttribute('data-metal', metal);
          if (v.count !== currentCount) applyCount(v.count);
          else syncHidden();
        }
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          sel.classList.remove('is-error');
          if (!root.querySelector('.wy-charms__select.is-error')) errorEl.hidden = true;
          refreshDisabled(); refreshPreview();
        });
      });
      resetBtn.addEventListener('click', function () {
        selects.forEach(function (s) { s.value = ''; s.classList.remove('is-error'); });
        errorEl.hidden = true; refreshDisabled(); refreshPreview();
      });

      function validate() {
        var ok = true, first = null;
        root.querySelectorAll('.wy-charms__row').forEach(function (row) {
          if (row.hidden) return;
          var sel = row.querySelector('select');
          if (!sel.value) { ok = false; sel.classList.add('is-error'); if (!first) first = sel; }
        });
        errorEl.hidden = ok;
        if (!ok && first) { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); first.focus(); }
        syncHidden();
        return ok;
      }

      function bindGuard() {
        var f = form(); if (!f) return;
        if (f.getAttribute('data-wy-charms-guard') !== '1') {
          f.setAttribute('data-wy-charms-guard', '1');
          f.addEventListener('submit', function (e) { if (!validate()) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } }, true);
          var add = f.querySelector('[name="add"]');
          if (add) add.addEventListener('click', function (e) { if (!validate()) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } }, true);
        }
      }

      // reaguj na zmianę wariantu (Horizon przerenderowuje form / zmienia input[name=id])
      document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-option, [data-block-type="variant-picker"]')) setTimeout(syncFromVariant, 50); }, true);
      document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-option, label[for]')) setTimeout(syncFromVariant, 80); }, true);
      var pending = null;
      new MutationObserver(function (muts) {
        var relevant = muts.some(function (m) { return !(m.target && m.target.hasAttribute && m.target.hasAttribute('data-wy-charms-mirror')) && !(root.contains(m.target)); });
        if (!relevant || pending) return;
        pending = setTimeout(function () { pending = null; bindGuard(); syncFromVariant(); }, 120);
      }).observe(document.body, { childList: true, subtree: true });

      bindGuard();
      applyCount(defaultCount);
      syncFromVariant();
    }

    function init() { document.querySelectorAll('[data-wy-charms]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-collection-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-collection-grid')) {
    customElements.define('wy-collection-grid', class extends HTMLElement {
      connectedCallback() {
        const carousel = this.querySelector('[data-carousel]');
        const cards = this.querySelectorAll('[data-card]');
        const dotsBox = this.querySelector('[data-dots]');
        if (!carousel || !dotsBox || window.innerWidth > 768) return;
        dotsBox.innerHTML = '';
        cards.forEach((c, i) => { const d = document.createElement('div'); d.className = 'ai-collection-grid__dot' + (i === 0 ? ' active' : ''); dotsBox.appendChild(d); });
        const dots = dotsBox.children; let cur = 0, t;
        carousel.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => {
          const w = cards[0].offsetWidth; const gap = parseInt(getComputedStyle(carousel).gap) || 0;
          const n = Math.round(carousel.scrollLeft / (w + gap));
          if (n !== cur && dots[n]) { dots[cur].classList.remove('active'); dots[n].classList.add('active'); cur = n; }
        }, 100); }, { passive: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-faq')) {
    customElements.define('wy-faq', class extends HTMLElement {
      connectedCallback() {
        this.items = this.querySelectorAll('[data-faq-item]');
        this.items.forEach((item) => {
          const btn = item.querySelector('.ai-faq-question-button');
          btn.addEventListener('click', () => {
            const active = item.classList.contains('active');
            this.items.forEach((o) => { if (o !== item) this.close(o); });
            active ? this.close(item) : this.open(item);
          });
        });
      }
      open(item) { item.classList.add('active'); item.querySelector('button').setAttribute('aria-expanded', 'true'); const w = item.querySelector('.ai-faq-answer-wrapper'); w.style.maxHeight = w.firstElementChild.scrollHeight + 'px'; }
      close(item) { item.classList.remove('active'); item.querySelector('button').setAttribute('aria-expanded', 'false'); item.querySelector('.ai-faq-answer-wrapper').style.maxHeight = '0'; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-marquee')) customElements.define('wy-marquee', class extends HTMLElement {});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-perso"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__wyPersoInit) return; window.__wyPersoInit = true;
    function cartForm() {
      var f = document.querySelector('form[action*="/cart/add"]');
      if (!f) { var b = document.querySelector('[name="add"]'); if (b) f = b.closest('form'); }
      return f;
    }
    function fields() { return Array.prototype.slice.call(document.querySelectorAll('[data-wy-perso]')); }
    function sync(form) {
      fields().forEach(function (input) {
        var name = 'properties[' + input.getAttribute('data-property') + ']';
        var hidden = null;
        Array.prototype.forEach.call(form.querySelectorAll('input[type="hidden"]'), function (h) { if (h.name === name) hidden = h; });
        if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = name; form.appendChild(hidden); }
        hidden.value = input.value || '';
      });
    }
    function validate(form) {
      var ok = true;
      sync(form);
      fields().forEach(function (input) {
        if (input.getAttribute('data-required') === 'true' && input.value.trim() === '') {
          ok = false; input.classList.add('custom-perso-error');
          var e = document.getElementById(input.id + '-error'); if (e) e.classList.add('custom-perso-error-visible');
          input.scrollIntoView({ behavior: 'smooth', block: 'center' }); input.focus();
        }
      });
      return ok;
    }
    function init() {
      var form = cartForm(); if (!form) return;
      fields().forEach(function (input) {
        if (input.dataset.bound) return; input.dataset.bound = '1';
        input.addEventListener('input', function () {
          sync(form);
          if (input.value.trim() !== '') { input.classList.remove('custom-perso-error'); var e = document.getElementById(input.id + '-error'); if (e) e.classList.remove('custom-perso-error-visible'); }
        });
      });
      sync(form);
      if (!form.dataset.wyGuard) {
        form.dataset.wyGuard = '1';
        form.addEventListener('submit', function (e) { if (!validate(form)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } }, true);
      }
      document.querySelectorAll('[name="add"], .sticky-add-to-cart__button').forEach(function (btn) {
        if (btn.dataset.wyGuard) return; btn.dataset.wyGuard = '1';
        btn.addEventListener('click', function (e) { if (!validate(form)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } }, true);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-reviews-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-review-carousel')) {
    customElements.define('wy-review-carousel', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const cards = this.querySelectorAll('[data-card]');
        const dotsBox = this.querySelector('[data-dots]');
        if (!track || !cards.length) return;
        dotsBox.innerHTML = '';
        const dots = [];
        cards.forEach((c, i) => {
          const d = document.createElement('span');
          d.className = 'pdp-review-carousel__dot' + (i === 0 ? ' pdp-review-carousel__dot--active' : '');
          d.addEventListener('click', () => { track.scrollTo({ left: c.offsetLeft, behavior: 'smooth' }); });
          dotsBox.appendChild(d); dots.push(d);
        });
        let idx = 0;
        const setActive = (i) => { dots.forEach((d, k) => d.classList.toggle('pdp-review-carousel__dot--active', k === i)); idx = i; };
        track.addEventListener('scroll', () => { const w = cards[0].offsetWidth || 1; setActive(Math.round(track.scrollLeft / w)); }, { passive: true });
        this._timer = setInterval(() => { if (this.matches(':hover')) return; const next = (idx + 1) % cards.length; track.scrollTo({ left: cards[next].offsetLeft, behavior: 'smooth' }); }, 5000);
      }
      disconnectedCallback() { clearInterval(this._timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
